import { createApiRef } from "@backstage/core-plugin-api";

export const GenAIBackendAPIiRef = createApiRef<GenAIApimOperations>({
  id: 'plugin.genaiplatform-frontend.service',
});

export interface GenAIApimOperations {
  getGenAI_APIMSubscriptions(email: string): Promise<Subscription[]>;
  createGenAI_APIMSubscriptions(email: string): Promise<NewSubscription>;
  regenerateGenAI_APIMSubscriptions(id: string): Promise<void>;
  getGenAI_LiteLLMKeyInfo(email: string): Promise<LiteLLMKeyInfo>;
}

export type Subscription = {
  allowTracing: string,
  createdDate: string,
  displayName: string,
  endDate: string,
  expirationDate: string,
  id: string,
  name: string,
  notificationDate: string,
  ownerId: string,
  scope: string,
  startDate: string,
  state: string,
  stateComment: string,
  type: string,
  primaryKey?: string,
  secondaryKey?: string,
}

export type NewSubscription = {
  subscriptionId: string,
  primaryKey: string,
  secondaryKey: string,
}

export type LiteLLMKeyInfo = {
  maxBudget: number | null,
  spend: number | null,
  remaining: number | null,
  budgetResetAt: string | null,
  periodSpend: number,
  periodSpendByModel: Record<string, number>,
}
